module.exports = __webpack_public_path__ + "img/loading.49506b92.gif";